import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosClient, getBaseUrlVersioned } from "../../../services/axiosClient";
import { VOICE_ACTIONS } from "./types";
const API_PATH_VOICES = "voices";
const API_PATH_CONVERSATIONS = "conversation";
const initialState = {
    allVoices: [],
    loading: {
        isLoading: false,
        loadingType: null,
    },
};
const handlePending = (state, loadingType) => {
    state.loading = {
        loadingType,
        isLoading: true,
    };
};
const resetLoading = (state) => {
    state.loading = {
        loadingType: null,
        isLoading: false,
    };
};
export const getAllVoices = createAsyncThunk(VOICE_ACTIONS.GET_ALL_VOICES, async () => {
    try {
        const apiUrl = `${getBaseUrlVersioned("")}/${API_PATH_VOICES}`;
        const response = await axiosClient.get(apiUrl);
        return response?.data;
    }
    catch (error) {
        throw error;
    }
});
export const getVoiceLanguages = createAsyncThunk(VOICE_ACTIONS.GET_VOICE_LANGUAGES, async () => {
    try {
        const apiUrl = `${getBaseUrlVersioned("")}/${API_PATH_VOICES}/languages`;
        const response = await axiosClient.get(apiUrl);
        return response?.data;
    }
    catch (error) {
        throw error;
    }
});
export const saveConversationVoiceId = createAsyncThunk(VOICE_ACTIONS.SAVE_CONVERSATION_VOICE_ID, async (params) => {
    try {
        const { conversation_id, voice_id } = params;
        const apiUrl = `${getBaseUrlVersioned("")}/${API_PATH_CONVERSATIONS}/${conversation_id}`;
        const response = await axiosClient.patch(apiUrl, { conversation_id, voice_id });
        return response?.data;
    }
    catch (error) {
        throw error;
    }
});
export const rateVoiceQuality = createAsyncThunk(VOICE_ACTIONS.RATE_VOICE_QUALITY, async (params) => {
    try {
        const { message_id, voice_id, label } = params;
        const apiUrl = `${getBaseUrlVersioned("")}/${API_PATH_VOICES}/${voice_id}/label`;
        const response = await axiosClient.post(apiUrl, { message_id, label });
        return response?.data;
    }
    catch (error) {
        throw error;
    }
});
export const createConversationAndSetVoiceId = createAsyncThunk(VOICE_ACTIONS.RATE_VOICE_QUALITY, async (params) => {
    try {
        const { characterId, selectedVoiceId, defaultPersonaId } = params;
        const apiUrl = `${getBaseUrlVersioned("")}/characters/${characterId}/conversations?withVoice=true`;
        const response = await axiosClient.post(apiUrl, {
            user_persona_id: defaultPersonaId,
            voice_id: selectedVoiceId,
        });
        return response?.data;
    }
    catch (error) {
        throw error;
    }
});
export const voiceSlice = createSlice({
    name: "voice",
    initialState: initialState,
    reducers: {
        setAllVoices: (state, action) => {
            state.allVoices = action.payload;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(getAllVoices.pending, (state) => {
            handlePending(state, VOICE_ACTIONS.GET_ALL_VOICES);
        })
            .addCase(getAllVoices.fulfilled, (state, action) => {
            resetLoading(state);
            state.allVoices = action.payload;
        })
            .addCase(getAllVoices.rejected, (state) => {
            resetLoading(state);
        })
            .addCase(rateVoiceQuality.pending, (state) => {
            handlePending(state, VOICE_ACTIONS.RATE_VOICE_QUALITY);
        })
            .addCase(rateVoiceQuality.fulfilled, (state) => {
            resetLoading(state);
        })
            .addCase(rateVoiceQuality.rejected, (state) => {
            resetLoading(state);
        });
    },
});
export const { setAllVoices } = voiceSlice.actions;
export default voiceSlice.reducer;
